// Libraries
import React from 'react';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';
import ModalV2, { DefaultFooterButtons } from '@/views/components/modals/ModalV2';

// Utils
import { MODAL_SIZES } from '@/utils/constants';

type Props = {
  onCancel: () => void;
  onConfirm?: () => void;
  show?: boolean;
};

export const ConfirmUnlockPortfolioValueModal = ({ show, onCancel, onConfirm, ...rest }: Props) => {
  const basei18n = 'PortfolioEditorBuilder.ConfirmUnlockPortfolioValueModal';

  const body = <FormattedMessageV2 toLocalize={`${basei18n}.Body`} />;

  const title = `${basei18n}.Title`;

  const footerButtonsConfig: DefaultFooterButtons = {
    cancelLabelToLocalize: `${basei18n}.CancelButton`,
    cancelOnClick: onCancel,
    primaryLabelToLocalize: `${basei18n}.ConfirmButton`,
    primaryOnClick: onConfirm,
  };

  return (
    <ModalV2
      size={MODAL_SIZES.SM}
      modalClassName="confirm-unlock-portfolio-value-modal body-sm"
      show={show}
      title={title}
      onClose={onCancel}
      body={body}
      defaultFooterButtons={footerButtonsConfig}
      {...rest}
    />
  );
};
